/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateClaimLinkRequest
 */
export interface CreateClaimLinkRequest {
    /**
     * Display label for the link
     * @type {string}
     * @memberof CreateClaimLinkRequest
     */
    label: string;
    /**
     * Full URL (must include protocol)
     * @type {string}
     * @memberof CreateClaimLinkRequest
     */
    url: string;
}

/**
 * Check if a given object implements the CreateClaimLinkRequest interface.
 */
export function instanceOfCreateClaimLinkRequest(value: object): value is CreateClaimLinkRequest {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function CreateClaimLinkRequestFromJSON(json: any): CreateClaimLinkRequest {
    return CreateClaimLinkRequestFromJSONTyped(json, false);
}

export function CreateClaimLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClaimLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'url': json['url'],
    };
}

export function CreateClaimLinkRequestToJSON(json: any): CreateClaimLinkRequest {
    return CreateClaimLinkRequestToJSONTyped(json, false);
}

export function CreateClaimLinkRequestToJSONTyped(value?: CreateClaimLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'url': value['url'],
    };
}

